import type { ContentReactionType } from "@circle-react/types/ContentReaction";
import type { SentimentProps } from "@circleco/compass/components/Sentiment";

interface ReactionPresentation {
  labelKey: string;
  selectedClassName: string;
  sentiment: SentimentProps["kind"];
}

export const REACTION_PRESENTATION: Record<
  ContentReactionType,
  ReactionPresentation
> = {
  like: {
    labelKey: "reactions.types.like",
    selectedClassName: "icon-sentiment-like",
    sentiment: "like",
  },
  celebrate: {
    labelKey: "reactions.types.celebrate",
    selectedClassName: "icon-sentiment-celebrate",
    sentiment: "celebrate",
  },
  love: {
    labelKey: "reactions.types.love",
    selectedClassName: "icon-sentiment-love",
    sentiment: "love",
  },
  support: {
    labelKey: "reactions.types.support",
    selectedClassName: "icon-sentiment-support",
    sentiment: "support",
  },
  insightful: {
    labelKey: "reactions.types.insightful",
    selectedClassName: "icon-sentiment-idea",
    sentiment: "idea",
  },
  funny: {
    labelKey: "reactions.types.funny",
    selectedClassName: "icon-sentiment-funny",
    sentiment: "funny",
  },
};

export const SENTIMENT_TO_REACTION_TYPE: Record<
  SentimentProps["kind"],
  ContentReactionType
> = {
  like: "like",
  celebrate: "celebrate",
  support: "support",
  love: "love",
  idea: "insightful",
  funny: "funny",
};

export const DEFAULT_REACTION_TYPE: ContentReactionType = "like";
export const REACTIONABLE_TYPES = {
  comment: "comment",
  post: "post",
} as const;
